import { render, staticRenderFns } from "./ARadioGroup.vue?vue&type=template&id=5c4aaf56&"
import script from "./ARadioGroup.vue?vue&type=script&lang=js&"
export * from "./ARadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./ARadioGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports